import React from 'react';

import Link from 'depop/components/Link';

import { FormattedMessage } from 'react-intl';

const AboutLink = props =>
  <Link to={{ pathname: '/about/' }} {...props}>
    <FormattedMessage
      id="app.aboutLabel"
      description="About Label"
      defaultMessage="About"
    />
  </Link>;

export default AboutLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/AboutLink.js